import { render, staticRenderFns } from "./RegistroUsuario.vue?vue&type=template&id=53ce469b&"
import script from "./RegistroUsuario.vue?vue&type=script&lang=js&"
export * from "./RegistroUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports